/**
 * Searchbar Module
 * @dependencies gsap > 3.0
 */

import { gsap } from 'gsap';

window.addEventListener('load', function() {

  // DOM Elements
  const searchModule = document.querySelector('.search-module');
  if ( ! searchModule )
    return;

  const searchDisplay = document.querySelector('.js-search-module-display');
  const searchToggle = searchModule.querySelectorAll('.js-search-module-open, .js-search-module-close, .js-search-module-backdrop');
  const searchBg = searchModule.querySelector('.js-search-module-bg');
  const searchBackdrop = searchModule.querySelector('.js-search-module-backdrop');
  const searchContent = searchModule.querySelector('.js-search-module-content');
  const searchClose = searchModule.querySelector('.js-search-module-close');
  const searchInput = searchModule.querySelector('input[type="search"]');

  // Events
  let searchOpened = false;
  if (searchToggle.length){
    searchToggle.forEach((el) => {
      el.addEventListener('click', (ev) => {
        ev.preventDefault();

        if (searchOpened) {
          // Closing Tween
          const tl = gsap.timeline();
          tl.to(searchBg, { duration: 0.5, scaleY: 0, ease: "power3.out" }, 'start');
          tl.to(searchContent, { duration: 0.5, y: -80, autoAlpha: 0, ease: "power3.out" }, 'start+=0');
          tl.to(searchBackdrop, { duration: 0.5, autoAlpha: 0 }, 'start+=0');
          tl.to(searchClose,  { duration: 0.4, autoAlpha: 0, ease: "power3.out" }, 'start+=0');
          tl.set(searchDisplay, { autoAlpha: 0 });
          searchOpened = false;
        } else {
          // Opening Tween
          const tl = gsap.timeline({onComplete: function() {
          // When the opening is complete, toggle the focus on the inputsearchInput.focus();
          }});
          tl.set(searchDisplay, { autoAlpha: 1 }, 'start');
          tl.fromTo(searchBackdrop, { duration: 0.5, autoAlpha: 0 }, { autoAlpha: 1 }, 'start+=0');
          tl.fromTo(searchBg, { duration: 0.5, scaleY: 0, ease: "power3.out"  }, { scaleY: 1, ease: "power3.out"  }, 'start+=0');
          tl.fromTo(searchClose, { duration: 0.5, y: -80, autoAlpha: 0, ease: "power3.out"  }, { y: 0, autoAlpha: 1, ease: "power3.out"  }, 'start+=0.1');
          tl.fromTo(searchContent, { duration: 0.5, y: -80, autoAlpha: 0, ease: "power3.out"  }, { y: 0, autoAlpha: 1, ease: "power3.out"  }, 'start+=0.15');
          searchOpened = true;
        }
      })
    });
  }
});
